import { ApiAddress } from '@/services/apis'
import { ID } from '@/services/common.model'
import { Project } from '@/services/project/project.model'
import request from '@/services/request'
import { PropertySetModule } from '../admin/property-set/modal'
import { Member } from '../member/member.model'

export function getProjects(): Promise<Project.Info[]> {
  return request.get(ApiAddress.PROJECTS).then((datas: any) => {
    return datas.map((item) => {
      item.prefix = 'projects'
      return item
    })
  })
}


export function getOrganizationProjects(id: ID): Promise<Project.Info[]> {
  return request.get(ApiAddress.ORGANIZATION_PROJECTS, { params: { id } })
}

export function createOrganizationProject(id: ID, rId: ID, data: Project.Base) {
  return request.post(ApiAddress.ORGANIZATION_PROJECTS, data, { params: { id, rId } })
}



export function updateOrganizationProject(params: { id: number; orgId: number }, data: Project.Base) {
  return request.put(ApiAddress.ORGANIZATION_PROJECT, data, { params })
}

export function deleteProject(id: number) {
  return request.delete(ApiAddress.PROJECT_TYPE_ITEM, { params: { projectType: 'projects', projectId: id } })
}

// params: {projectType, projectId}
export function getUserProjectRole(params: { projectId: number | string }) {
  return request.get(ApiAddress.USER_PROJECT_ROLE, { params })
}

export function getAllPropertySets(): Promise<PropertySetModule.Modal[]> {
  return request.get(ApiAddress.ALL_PROPERTY_SETS)
}

export function getProjectPropertySets(params): Promise<PropertySetModule.Modal[]> {
  return request.get(ApiAddress.PROJECT_PROPERTY_SETS, {params})
}

export function addPropertySetToProject(params) {
  return request.post(ApiAddress.PROJECT_PROPERTY_SET, {}, {params})
}

export function deletePropertySetFromProject(params) {
  return request.delete(ApiAddress.PROJECT_PROPERTY_SET, {params})
}

export function getPropertySet(pId: string, id: number): Promise<PropertySetModule.Modal | undefined> {
  return getProjectPropertySets({pId}).then((sets) => {
    return sets.find(item => item.id === id)
  })
}

export function getUserProjectAccount(id: ID): Promise<Member.Info> {
  return request.get(ApiAddress.USER_PROJECT_ACCOUNT, { params: { id } })
}